export type PlayerData = framework.ui.PlayerData;

export function createPlayerData() {
  return new cast.framework.ui.PlayerData();
}

export function bindPlayerData(playerData: framework.ui.PlayerData) {
  return new cast.framework.ui.PlayerDataBinder(playerData);
}
